import { FC, useMemo } from "react";
import { ColumnDef, getCoreRowModel, useReactTable } from "@tanstack/react-table";
import GenericTable from "./GenericTable";
import type { IAsset } from "@api/IWalletController";
import DynamicRelativeTime from "./cells/DynamicTimer";
import TokenAsset from "./cells/TokenCell";
import ContractAddress from "./cells/ContractCell";
import PriceDisplay from "./cells/PriceCell";
import ActionButton from "./cells/ActionButton";
import { NewToken } from "../types/index.types";
interface ListingTableProps {
    history: NewToken[];
}

const ListingTable: FC<ListingTableProps> = ({ history }) => {
    const columns = useMemo<ColumnDef<NewToken>[]>(
        () => [
            {
                accessorKey: "asset1",
                header: "Pair",
                cell: ({ getValue }) => {
                    const asset = getValue<IAsset>();
                    return <TokenAsset asset={asset} />;
                },
            },
            {
                accessorKey: "tokenOrPoolAddress",
                header: "Contract",
                cell: ({ getValue }) => {
                    const contract = getValue<string>();
                    return <ContractAddress contract={contract} />;
                },
            },
            {
                accessorKey: "price",
                header: "Price",
                cell: ({ getValue }) => {
                    const value = getValue<number>();
                    return <PriceDisplay value={value} />;
                },
            },
            {
                accessorKey: "marketCap",
                header: "MCap",
                cell: ({ getValue }) => {
                    const value = getValue<number>();
                    return <PriceDisplay value={value} />;
                },
            },
            {
                accessorKey: "liquidity",
                header: "Liquidity",
                cell: ({ getValue }) => {
                    const value = getValue<number>();
                    return <PriceDisplay value={value} />;
                },
            },
            {
                accessorKey: "dex",
                header: "Listing",
                cell: ({ getValue }) => <span>{getValue<string>()}</span>,
            },
            {
                accessorKey: "createdAt",
                header: "Time Listing",
                cell: ({ row }) => {
                    const timeString = row.original.createdAt;
                    return <DynamicRelativeTime dateString={timeString} />;
                },
            },
            {
                header: "Action",
                cell: () => <ActionButton />,
            },
        ],
        [],
    );

    const table = useReactTable({
        data: history,
        columns,
        getCoreRowModel: getCoreRowModel(),
    });

    return <GenericTable table={table} title="Listing Checker" theadZIndex="z-10" />;
};

export default ListingTable;
